import { render, staticRenderFns } from "./WagonDialog.vue?vue&type=template&id=4b92b18c&scoped=true&"
import script from "./WagonDialog.vue?vue&type=script&lang=js&"
export * from "./WagonDialog.vue?vue&type=script&lang=js&"
import style0 from "./WagonDialog.vue?vue&type=style&index=0&id=4b92b18c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b92b18c",
  null
  
)

export default component.exports